import { Fragment } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, Dialog, DialogError, DialogLoading } from '@pocketlaw/tetris';
/**
 * A component to handle the state of a dialog, including loading and error states.
 *
 * Renders children when there is no loading or error state.
 *
 * @example
 * ```tsx
 * <DialogState state={{ loading, error }} onClose={onClose} onRefetch={onRefetch}>
 *   ...wrapped <Dialog /> and its content
 * </DialogState>
 * ```
 */
export function DialogState(props) {
    const { children, state, onClose, onRefetch, loading, error } = props;
    const errorProps = {
        title: t({ message: 'Error', comment: 'Dialog state title - Error' }),
        description: t({
            message: 'Something went wrong while loading the dialog, please try again.',
            comment: 'Generic form dialog error',
        }),
        actions: (<Fragment>
        <Button type="button" appearance="secondary" size="small" onClick={onClose}>
          <Trans comment="Generic form dialog error">Close</Trans>
        </Button>
        {onRefetch && (<Button type="button" size="small" onClick={() => onRefetch()}>
            <Trans comment="Generic form dialog error">Try again</Trans>
          </Button>)}
      </Fragment>),
    };
    if (state === null || state === void 0 ? void 0 : state.loading) {
        return (<Dialog>
        <DialogLoading {...loading}/>
      </Dialog>);
    }
    if (state === null || state === void 0 ? void 0 : state.error) {
        return (<Dialog>
        <DialogError {...(error || errorProps)}/>
      </Dialog>);
    }
    return children;
}
